import React from "react";
import { ButtonBase, ThemeProvider, theme } from "@reusejs/react";
import { XIcon } from "@heroicons/react/solid";
import { amountInWords, convertAmmountToWords } from "services";

const newTheme = {
  ...theme,
  variants: {},
};

export default function ConfirmBidModal(props: any) {
  return (
    <ThemeProvider value={newTheme}>
      <div className="relative shadow-sm flex flex-col">
        <div className="flex-1">
          <div
            className={
              "absolute z-50 -top-4 -right-4 rounded-full bg-gray-50 items-center px-2 py-2 border-b text-xs text-gray-900"
            }
          >
            <div
              className="cursor-pointer"
              onClick={() => props.onAction("no")}
            >
              <XIcon className="h-4 w-4" aria-hidden="true" />
            </div>
          </div>
          <div className={"relative border-b " + props.color}>
            <div className="px-4 lg:px-8">
              <div className="relative py-6 text-center">
                <h2 className="text-xl font-semibold tracking-tight">
                  {props.heading}
                </h2>
              </div>
            </div>
          </div>
          <div className="p-4 text-center max-w-lg">
            {/* <div className="mt-2 min-h-max ext-sm font-medium leading-6 text-yellow-500">
              {props.connectionStatus === "Connecting" &&
                "Slow connection alert! Connect to high-speed internet for smoother bidding. Check bid status in 'Bids History > Correct Bids/Your Failed Bids'."}
            </div> */}
            <div className="mt-2 min-h-max text-lg text-gray-500">
              {props.description}
            </div>
            <div className="space-y-3">
              <div>
                <span className="text-xl font-semibold">
                  ₹ {props.biddingAmount}
                </span>
              </div>
              <div>
                <span className="text-2xl font-semibold">
                  {convertAmmountToWords(props.biddingAmount) === "overflow"
                    ? "Bidding amount is extremely high check before you confirm"
                    : `₹ ${convertAmmountToWords(props.biddingAmount)}`}
                </span>
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center px-6 py-4 border-t">
            <ButtonBase
              variant="primary"
              type="button"
              label="Confirm"
              onClick={() => {
                props.callback();
                props.onAction("no");
              }}
              buttonBaseClasses={{
                font: "text-sm font-medium",
                backgroundColor: "bg-green-600 hover:bg-green-700",
                textColor: "text-white",
                border: "any",
                padding: "px-8 py-3",
              }}
            />
            <ButtonBase
              variant="primary"
              type="button"
              label="Decline"
              onClick={() => {
                props.onAction("no");
              }}
              buttonBaseClasses={{
                font: "text-sm font-medium",
                backgroundColor: "bg-red-600 hover:bg-red-700",
                textColor: "text-white",
                border: "any",
                padding: "px-8 py-3",
              }}
            />
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
